import { RadioSingleSelect } from '@components/primitives/HtmlForm/RadioSingleSelect.client'
import { Text } from '@components/primitives/Text'
import EligibilityToggleValue from '@components/primitives/ToggleButton/EligibilityToggleGroup/EligibilityToggleValue'
import { faCheck } from '@fortawesome/pro-regular-svg-icons/faCheck'
import { faQuestion } from '@fortawesome/pro-regular-svg-icons/faQuestion'
import { faTimes } from '@fortawesome/pro-regular-svg-icons/faTimes'
import pluralize from '@lib/utilities/text/pluralize'
import type { ClinicalTrialTimeline } from '@prisma/client'
import { debounceTrackQuestionModified } from './trackQuestionModified'
import type { ConditionCollectElementProps } from './types'

const debouncedEventTracking = debounceTrackQuestionModified(
  'areCurrentSubstancesWillingToStop',
)

export default function CollectAreCurrentSubstancesWillingToStop({
  formRef,
  patientProfileData: { areCurrentSubstancesWillingToStop, currentSubstances },
  questionConfig,
  trialTimeline,
}: ConditionCollectElementProps) {
  const handleInputChange = (newInputValue: string) => {
    debouncedEventTracking(newInputValue)
    if (formRef && formRef.current) {
      formRef.current.requestSubmit()
    }
  }

  return (
    <div className='flex w-full flex-col gap-2'>
      <Text
        className='text-neutral900'
        element='p'
        styleName='h3'
        value={
          currentSubstances.length > 1
            ? `Would you be willing to stop using these substances for the ${getStudyDurationText(trialTimeline)}?`
            : `Would you be willing to stop using ${currentSubstances[0]} for the ${getStudyDurationText(trialTimeline)}?`
        }
      />
      <div className='grid grid-cols-3 gap-2'>
        <RadioSingleSelect
          defaultValue={areCurrentSubstancesWillingToStop[0]}
          name={questionConfig.id}
          onChange={handleInputChange}
          options={[
            {
              icon: faCheck,
              label: 'Yes',
              value: EligibilityToggleValue.YES,
            },
            { icon: faTimes, label: 'No', value: EligibilityToggleValue.NO },
            {
              icon: faQuestion,
              label: 'Unsure',
              value: EligibilityToggleValue.UNSURE,
            },
          ]}
          required={!questionConfig.skippable}
        />
      </div>
    </div>
  )
}

function getStudyDurationText(trialTimeline: ClinicalTrialTimeline | null) {
  if (
    trialTimeline?.treatmentDuration &&
    trialTimeline?.treatmentDurationUnit
  ) {
    const duration = pluralize(
      trialTimeline.treatmentDurationUnit.toLowerCase(),
      1,
      { includeCount: false },
    )
    return `${trialTimeline.treatmentDuration}-${duration} duration of the study`
  } else {
    return 'study duration'
  }
}
